var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCosmetic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nav-3-a",
    d: "M0 0L29.839 0 29.839 29.838 0 29.838z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nav-3-c",
    d: "M0 0L9.952 0 9.952 9.953 0 9.953z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.162 2.162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nav-3-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nav-3-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.5823392,27.582089 C27.2017826,27.9626455 26.5868833,27.9626455 26.2063268,27.582089 L8.44635279,9.82411794 L9.82436814,8.44610259 L27.5823392,26.2060766 C27.9608928,26.5866331 27.9608928,27.2015324 27.5823392,27.582089 M29.0004131,24.8741286 L4.96726462,0.838977172 C3.84762715,-0.280660298 2.03898201,-0.278657369 0.9233504,0.838977172 L0.835221511,0.923100202 C-0.27840717,2.04073474 -0.27840717,3.84737696 0.835221511,4.9650115 L24.8703729,29.0001629 C25.9900104,30.1177974 27.7986555,30.1177974 28.9142871,29.0001629 L29.0004131,28.9160399 C30.1180476,27.7984053 30.1180476,25.9877573 29.0004131,24.8741286",
    mask: "url(#nav-3-b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.023 5.977L16.949 9.953 17.964 5.977 17.994 5.977 17.994 5.947 21.97 5.021 17.994 4.006 17.994 3.974 17.98 3.974 17.055 0 16.039 3.974 15.991 3.974 15.991 4.038 12.017 4.963 15.991 5.977z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nav-3-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nav-3-c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.931 9.953L5.946 5.977 5.976 5.977 5.976 5.947 9.952 5.021 5.976 4.006 5.976 3.974 5.962 3.974 5.037 0 4.021 3.974 3.973 3.974 3.973 4.038 0 4.963 3.973 5.977 4.005 5.977z",
    mask: "url(#nav-3-d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.983 24.003L9.967 24.003 9.042 20.029 8.026 24.003 7.98 24.003 7.98 24.067 4.006 24.993 7.98 26.006 8.012 26.006 8.938 29.982 9.951 26.006 9.983 26.006 9.983 25.976 13.957 25.051 9.983 24.035z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmetic);
export default __webpack_public_path__ + "static/media/Cosmetic.66952a4b.svg";
export { ForwardRef as ReactComponent };